// extracted by mini-css-extract-plugin
export default {"content":"Staff_content__P5Jam","topBox":"Staff_topBox__eq-2b"};